import * as React from 'react';

import { PropertySpaces } from '@shared-ui/lodging-property-details';

import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

const PropertySpacesWrapper: React.FC<SharedUiWrapperProps & { className?: string }> = ({ inputs }) => <PropertySpaces inputs={inputs} />;
PropertySpacesWrapper.displayName = 'SpaceDetailsWrapper';

export const SharedUiPropertySpacesWrapper = withSharedUiPropertyDetails(PropertySpacesWrapper);
SharedUiPropertySpacesWrapper.displayName = 'SharedUiPropertySpacesWrapper';
